module.exports = __webpack_public_path__ + "static/media/icmbio.4591360a.png";